// Entities
export const ENTITIES_ADD = 'ENTITIES_ADD';
export const ENTITIES_MUTATE = 'ENTITIES_MUTATE';
export const ENTITIES_REPLACE = 'ENTITIES_REPLACE';
export const ENTITIES_REMOVE = 'ENTITIES_REMOVE';

// Activities
export const ACTIVITY_MARK = 'ACTIVITY_MARK';
export const ACTIVITY_RESET = 'ACTIVITY_RESET';

// Redux form
export const FORM_REPLACE = 'FORM_REPLACE';

// Auth
export const AUTH_LOGIN_REQUEST = 'AUTH_LOGIN_REQUEST';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

// Password
export const PASSWORD_FORGOT_REQUEST = 'PASSWORD_FORGOT_REQUEST';
export const PASSWORD_FORGOT_FAILURE = 'PASSWORD_FORGOT_FAILURE';
export const PASSWORD_FORGOT_SUCCESS = 'PASSWORD_FORGOT_SUCCESS';
export const PASSWORD_RESET_REQUEST = 'PASSWORD_RESET_REQUEST';
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';

// Users
export const USER_SET = 'USER_SET';
export const USER_RESET_MESSAGE = 'USER_RESET_MESSAGE';
export const USERS_FETCH_REQUEST = 'USERS_FETCH_REQUEST';
export const USERS_FETCH_FAILURE = 'USERS_FETCH_FAILURE';
export const USERS_FETCH_SUCCESS = 'USERS_FETCH_SUCCESS';
export const USER_FETCH_REQUEST = 'USER_FETCH_REQUEST';
export const USER_FETCH_FAILURE = 'USER_FETCH_FAILURE';
export const USER_FETCH_SUCCESS = 'USER_FETCH_SUCCESS';
export const USER_LOGGED_IN_FETCH_REQUEST = 'USER_LOGGED_IN_FETCH_REQUEST';
export const USER_LOGGED_IN_FETCH_FAILURE = 'USER_LOGGED_IN_FETCH_FAILURE';
export const USER_LOGGED_IN_FETCH_SUCCESS = 'USER_LOGGED_IN_FETCH_SUCCESS';
export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST';
export const USER_UPDATE_FAILURE = 'USER_UPDATE_FAILURE';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_CREATE_REQUEST = 'USER_CREATE_REQUEST';
export const USER_CREATE_FAILURE = 'USER_CREATE_FAILURE';
export const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS';
export const USER_AVATAR_UPDATE_REQUEST = 'USER_AVATAR_UPDATE_REQUEST';
export const USER_AVATAR_UPDATE_FAILURE = 'USER_AVATAR_UPDATE_FAILURE';
export const USER_AVATAR_UPDATE_SUCCESS = 'USER_AVATAR_UPDATE_SUCCESS';
export const USERS_BY_GROUP_FETCH_REQUEST = 'USERS_BY_GROUP_FETCH_REQUEST';
export const USERS_BY_GROUP_FETCH_FAILURE = 'USERS_BY_GROUP_FETCH_FAILURE';
export const USERS_BY_GROUP_FETCH_SUCCESS = 'USERS_BY_GROUP_FETCH_SUCCESS';

// Groups
export const GROUP_SET = 'GROUP_SET';
export const GROUP_RESET_MESSAGE = 'GROUP_RESET_MESSAGE';
export const GROUPS_FETCH_REQUEST = 'GROUPS_FETCH_REQUEST';
export const GROUPS_FETCH_FAILURE = 'GROUPS_FETCH_FAILURE';
export const GROUPS_FETCH_SUCCESS = 'GROUPS_FETCH_SUCCESS';
export const GROUP_FETCH_REQUEST = 'GROUP_FETCH_REQUEST';
export const GROUP_FETCH_FAILURE = 'GROUP_FETCH_FAILURE';
export const GROUP_FETCH_SUCCESS = 'GROUP_FETCH_SUCCESS';
export const GROUP_UPDATE_REQUEST = 'GROUP_UPDATE_REQUEST';
export const GROUP_UPDATE_FAILURE = 'GROUP_UPDATE_FAILURE';
export const GROUP_UPDATE_SUCCESS = 'GROUP_UPDATE_SUCCESS';
export const GROUP_CREATE_REQUEST = 'GROUP_CREATE_REQUEST';
export const GROUP_CREATE_FAILURE = 'GROUP_CREATE_FAILURE';
export const GROUP_CREATE_SUCCESS = 'GROUP_CREATE_SUCCESS';
export const GROUP_DELETE_REQUEST = 'GROUP_DELETE_REQUEST';
export const GROUP_DELETE_FAILURE = 'GROUP_DELETE_FAILURE';
export const GROUP_DELETE_SUCCESS = 'GROUP_DELETE_SUCCESS';
export const GROUPS_BY_TYPE_FETCH_REQUEST = 'GROUPS_BY_TYPE_FETCH_REQUEST';
export const GROUPS_BY_TYPE_FETCH_FAILURE = 'GROUPS_BY_TYPE_FETCH_FAILURE';
export const GROUPS_BY_TYPE_FETCH_SUCCESS = 'GROUPS_BY_TYPE_FETCH_SUCCESS';

// Pages
export const PAGE_SET = 'PAGE_SET';
export const PAGE_RESET_MESSAGE = 'PAGE_RESET_MESSAGE';
export const PAGES_FETCH_REQUEST = 'PAGES_FETCH_REQUEST';
export const PAGES_FETCH_FAILURE = 'PAGES_FETCH_FAILURE';
export const PAGES_FETCH_SUCCESS = 'PAGES_FETCH_SUCCESS';
export const PAGE_FETCH_REQUEST = 'PAGE_FETCH_REQUEST';
export const PAGE_FETCH_FAILURE = 'PAGE_FETCH_FAILURE';
export const PAGE_FETCH_SUCCESS = 'PAGE_FETCH_SUCCESS';
export const PAGE_UPDATE_REQUEST = 'PAGE_UPDATE_REQUEST';
export const PAGE_UPDATE_FAILURE = 'PAGE_UPDATE_FAILURE';
export const PAGE_UPDATE_SUCCESS = 'PAGE_UPDATE_SUCCESS';
export const PAGE_CREATE_REQUEST = 'PAGE_CREATE_REQUEST';
export const PAGE_CREATE_FAILURE = 'PAGE_CREATE_FAILURE';
export const PAGE_CREATE_SUCCESS = 'PAGE_CREATE_SUCCESS';
export const PAGE_DELETE_REQUEST = 'PAGE_DELETE_REQUEST';
export const PAGE_DELETE_FAILURE = 'PAGE_DELETE_FAILURE';
export const PAGE_DELETE_SUCCESS = 'PAGE_DELETE_SUCCESS';

// Page files
export const PAGE_FILE_RESET_MESSAGE = 'PAGE_FILE_RESET_MESSAGE';
export const PAGE_FILE_CREATE_REQUEST = 'PAGE_FILE_CREATE_REQUEST';
export const PAGE_FILE_CREATE_FAILURE = 'PAGE_FILE_CREATE_FAILURE';
export const PAGE_FILE_CREATE_SUCCESS = 'PAGE_FILE_CREATE_SUCCESS';
export const PAGE_FILES_FETCH_REQUEST = 'PAGE_FILES_FETCH_REQUEST';
export const PAGE_FILES_FETCH_FAILURE = 'PAGE_FILES_FETCH_FAILURE';
export const PAGE_FILES_FETCH_SUCCESS = 'PAGE_FILES_FETCH_SUCCESS';
export const PAGE_FILE_DELETE_REQUEST = 'PAGE_FILE_DELETE_REQUEST';
export const PAGE_FILE_DELETE_FAILURE = 'PAGE_FILE_DELETE_FAILURE';
export const PAGE_FILE_DELETE_SUCCESS = 'PAGE_FILE_DELETE_SUCCESS';

// Admin notifications
export const ADMIN_NOTIFICATION_SET = 'ADMIN_NOTIFICATION_SET';
export const ADMIN_NOTIFICATION_RESET_MESSAGE =
	'ADMIN_NOTIFICATION_RESET_MESSAGE';
export const ADMIN_NOTIFICATIONS_FETCH_REQUEST =
	'ADMIN_NOTIFICATIONS_FETCH_REQUEST';
export const ADMIN_NOTIFICATIONS_FETCH_FAILURE =
	'ADMIN_NOTIFICATIONS_FETCH_FAILURE';
export const ADMIN_NOTIFICATIONS_FETCH_SUCCESS =
	'ADMIN_NOTIFICATIONS_FETCH_SUCCESS';
export const ADMIN_NOTIFICATION_FETCH_REQUEST =
	'ADMIN_NOTIFICATION_FETCH_REQUEST';
export const ADMIN_NOTIFICATION_FETCH_FAILURE =
	'ADMIN_NOTIFICATION_FETCH_FAILURE';
export const ADMIN_NOTIFICATION_FETCH_SUCCESS =
	'ADMIN_NOTIFICATION_FETCH_SUCCESS';
export const ADMIN_NOTIFICATION_UPDATE_REQUEST =
	'ADMIN_NOTIFICATION_UPDATE_REQUEST';
export const ADMIN_NOTIFICATION_UPDATE_FAILURE =
	'ADMIN_NOTIFICATION_UPDATE_FAILURE';
export const ADMIN_NOTIFICATION_UPDATE_SUCCESS =
	'ADMIN_NOTIFICATION_UPDATE_SUCCESS';
export const ADMIN_NOTIFICATION_CREATE_REQUEST =
	'ADMIN_NOTIFICATION_CREATE_REQUEST';
export const ADMIN_NOTIFICATION_CREATE_FAILURE =
	'ADMIN_NOTIFICATION_CREATE_FAILURE';
export const ADMIN_NOTIFICATION_CREATE_SUCCESS =
	'ADMIN_NOTIFICATION_CREATE_SUCCESS';
export const ADMIN_NOTIFICATION_DELETE_REQUEST =
	'ADMIN_NOTIFICATION_DELETE_REQUEST';
export const ADMIN_NOTIFICATION_DELETE_FAILURE =
	'ADMIN_NOTIFICATION_DELETE_FAILURE';
export const ADMIN_NOTIFICATION_DELETE_SUCCESS =
	'ADMIN_NOTIFICATION_DELETE_SUCCESS';

// Product Information Sheets
export const PI_SHEET_SET = 'PI_SHEET_SET';
export const PI_SHEET_RESET_MESSAGE = 'PI_SHEET_RESET_MESSAGE';
export const PI_SHEETS_FETCH_REQUEST = 'PI_SHEETS_FETCH_REQUEST';
export const PI_SHEETS_FETCH_FAILURE = 'PI_SHEETS_FETCH_FAILURE';
export const PI_SHEETS_FETCH_SUCCESS = 'PI_SHEETS_FETCH_SUCCESS';
export const PI_SHEET_FETCH_REQUEST = 'PI_SHEET_FETCH_REQUEST';
export const PI_SHEET_FETCH_FAILURE = 'PI_SHEET_FETCH_FAILURE';
export const PI_SHEET_FETCH_SUCCESS = 'PI_SHEET_FETCH_SUCCESS';
export const PI_SHEET_UPDATE_REQUEST = 'PI_SHEET_UPDATE_REQUEST';
export const PI_SHEET_UPDATE_FAILURE = 'PI_SHEET_UPDATE_FAILURE';
export const PI_SHEET_UPDATE_SUCCESS = 'PI_SHEET_UPDATE_SUCCESS';
export const PI_SHEET_CREATE_REQUEST = 'PI_SHEET_CREATE_REQUEST';
export const PI_SHEET_CREATE_FAILURE = 'PI_SHEET_CREATE_FAILURE';
export const PI_SHEET_CREATE_SUCCESS = 'PI_SHEET_CREATE_SUCCESS';
export const PI_SHEET_DELETE_REQUEST = 'PI_SHEET_DELETE_REQUEST';
export const PI_SHEET_DELETE_FAILURE = 'PI_SHEET_DELETE_FAILURE';
export const PI_SHEET_DELETE_SUCCESS = 'PI_SHEET_DELETE_SUCCESS';

// Product Information categories
export const PI_CATEGORY_SET = 'PI_CATEGORY_SET';
export const PI_CATEGORY_RESET_MESSAGE = 'PI_CATEGORY_RESET_MESSAGE';
export const PI_CATEGORIES_FETCH_REQUEST = 'PI_CATEGORIES_FETCH_REQUEST';
export const PI_CATEGORIES_FETCH_FAILURE = 'PI_CATEGORIES_FETCH_FAILURE';
export const PI_CATEGORIES_FETCH_SUCCESS = 'PI_CATEGORIES_FETCH_SUCCESS';
export const PI_CATEGORY_FETCH_REQUEST = 'PI_CATEGORY_FETCH_REQUEST';
export const PI_CATEGORY_FETCH_FAILURE = 'PI_CATEGORY_FETCH_FAILURE';
export const PI_CATEGORY_FETCH_SUCCESS = 'PI_CATEGORY_FETCH_SUCCESS';
export const PI_CATEGORY_UPDATE_REQUEST = 'PI_CATEGORY_UPDATE_REQUEST';
export const PI_CATEGORY_UPDATE_FAILURE = 'PI_CATEGORY_UPDATE_FAILURE';
export const PI_CATEGORY_UPDATE_SUCCESS = 'PI_CATEGORY_UPDATE_SUCCESS';
export const PI_CATEGORY_CREATE_REQUEST = 'PI_CATEGORY_CREATE_REQUEST';
export const PI_CATEGORY_CREATE_FAILURE = 'PI_CATEGORY_CREATE_FAILURE';
export const PI_CATEGORY_CREATE_SUCCESS = 'PI_CATEGORY_CREATE_SUCCESS';
export const PI_CATEGORY_DELETE_REQUEST = 'PI_CATEGORY_DELETE_REQUEST';
export const PI_CATEGORY_DELETE_FAILURE = 'PI_CATEGORY_DELETE_FAILURE';
export const PI_CATEGORY_DELETE_SUCCESS = 'PI_CATEGORY_DELETE_SUCCESS';

// Product Information Sheets
export const PRODUCT_SET = 'PRODUCT_SET';
export const PRODUCT_RESET_MESSAGE = 'PRODUCT_RESET_MESSAGE';
export const PRODUCTS_FETCH_REQUEST = 'PRODUCTS_FETCH_REQUEST';
export const PRODUCTS_FETCH_FAILURE = 'PRODUCTS_FETCH_FAILURE';
export const PRODUCTS_FETCH_SUCCESS = 'PRODUCTS_FETCH_SUCCESS';
export const PRODUCT_FETCH_REQUEST = 'PRODUCT_FETCH_REQUEST';
export const PRODUCT_FETCH_FAILURE = 'PRODUCT_FETCH_FAILURE';
export const PRODUCT_FETCH_SUCCESS = 'PRODUCT_FETCH_SUCCESS';
export const PRODUCT_UPDATE_REQUEST = 'PRODUCT_UPDATE_REQUEST';
export const PRODUCT_UPDATE_FAILURE = 'PRODUCT_UPDATE_FAILURE';
export const PRODUCT_UPDATE_SUCCESS = 'PRODUCT_UPDATE_SUCCESS';
export const PRODUCT_CREATE_REQUEST = 'PRODUCT_CREATE_REQUEST';
export const PRODUCT_CREATE_FAILURE = 'PRODUCT_CREATE_FAILURE';
export const PRODUCT_CREATE_SUCCESS = 'PRODUCT_CREATE_SUCCESS';

// Bulletins
export const BULLETIN_SET = 'BULLETIN_SET';
export const BULLETIN_RESET_MESSAGE = 'BULLETIN_RESET_MESSAGE';
export const BULLETINS_FETCH_REQUEST = 'BULLETINS_FETCH_REQUEST';
export const BULLETINS_FETCH_FAILURE = 'BULLETINS_FETCH_FAILURE';
export const BULLETINS_FETCH_SUCCESS = 'BULLETINS_FETCH_SUCCESS';
export const BULLETIN_FETCH_REQUEST = 'BULLETIN_FETCH_REQUEST';
export const BULLETIN_FETCH_FAILURE = 'BULLETIN_FETCH_FAILURE';
export const BULLETIN_FETCH_SUCCESS = 'BULLETIN_FETCH_SUCCESS';
export const BULLETIN_UPDATE_REQUEST = 'BULLETIN_UPDATE_REQUEST';
export const BULLETIN_UPDATE_FAILURE = 'BULLETIN_UPDATE_FAILURE';
export const BULLETIN_UPDATE_SUCCESS = 'BULLETIN_UPDATE_SUCCESS';
export const BULLETIN_CREATE_REQUEST = 'BULLETIN_CREATE_REQUEST';
export const BULLETIN_CREATE_FAILURE = 'BULLETIN_CREATE_FAILURE';
export const BULLETIN_CREATE_SUCCESS = 'BULLETIN_CREATE_SUCCESS';

export const BULLETIN_DELETE_REQUEST = 'BULLETIN_DELETE_REQUEST';
export const BULLETIN_DELETE_FAILURE = 'BULLETIN_DELETE_FAILURE';
export const BULLETIN_DELETE_SUCCESS = 'BULLETIN_DELETE_SUCCESS';

// Bulletin tags
export const BULLETIN_TAG_SET = 'BULLETIN_TAG_SET';
export const BULLETIN_TAG_RESET_MESSAGE = 'BULLETIN_TAG_RESET_MESSAGE';
export const BULLETIN_TAGS_FETCH_REQUEST = 'BULLETIN_TAGS_FETCH_REQUEST';
export const BULLETIN_TAGS_FETCH_FAILURE = 'BULLETIN_TAGS_FETCH_FAILURE';
export const BULLETIN_TAGS_FETCH_SUCCESS = 'BULLETIN_TAGS_FETCH_SUCCESS';
export const BULLETIN_TAG_FETCH_REQUEST = 'BULLETIN_TAG_FETCH_REQUEST';
export const BULLETIN_TAG_FETCH_FAILURE = 'BULLETIN_TAG_FETCH_FAILURE';
export const BULLETIN_TAG_FETCH_SUCCESS = 'BULLETIN_TAG_FETCH_SUCCESS';
export const BULLETIN_TAG_UPDATE_REQUEST = 'BULLETIN_TAG_UPDATE_REQUEST';
export const BULLETIN_TAG_UPDATE_FAILURE = 'BULLETIN_TAG_UPDATE_FAILURE';
export const BULLETIN_TAG_UPDATE_SUCCESS = 'BULLETIN_TAG_UPDATE_SUCCESS';
export const BULLETIN_TAG_CREATE_REQUEST = 'BULLETIN_TAG_CREATE_REQUEST';
export const BULLETIN_TAG_CREATE_FAILURE = 'BULLETIN_TAG_CREATE_FAILURE';
export const BULLETIN_TAG_CREATE_SUCCESS = 'BULLETIN_TAG_CREATE_SUCCESS';

// Commissioning reports
export const CR_SET = 'CR_SET';
export const CR_RESET_MESSAGE = 'CR_RESET_MESSAGE';
export const CRS_FETCH_REQUEST = 'CRS_FETCH_REQUEST';
export const CRS_FETCH_FAILURE = 'CRS_FETCH_FAILURE';
export const CRS_FETCH_SUCCESS = 'CRS_FETCH_SUCCESS';
export const CR_FETCH_REQUEST = 'CR_FETCH_REQUEST';
export const CR_FETCH_FAILURE = 'CR_FETCH_FAILURE';
export const CR_FETCH_SUCCESS = 'CR_FETCH_SUCCESS';
export const CR_CREATE_REQUEST = 'CR_CREATE_REQUEST';
export const CR_CREATE_FAILURE = 'CR_CREATE_FAILURE';
export const CR_CREATE_SUCCESS = 'CR_CREATE_SUCCESS';
export const CR_UPDATE_REQUEST = 'CR_UPDATE_REQUEST';
export const CR_UPDATE_FAILURE = 'CR_UPDATE_FAILURE';
export const CR_UPDATE_SUCCESS = 'CR_UPDATE_SUCCESS';
export const CR_CLONE_REQUEST = 'CR_CLONE_REQUEST';
export const CR_CLONE_FAILURE = 'CR_CLONE_FAILURE';
export const CR_CLONE_SUCCESS = 'CR_CLONE_SUCCESS';

export const CR_DELETE_REQUEST = 'CR_DELETE_REQUEST';
export const CR_DELETE_FAILURE = 'CR_DELETE_FAILURE';
export const CR_DELETE_SUCCESS = 'CR_DELETE_SUCCESS';

export const CR_SURVEY_SEND_REQUEST = 'CR_SURVEY_SEND_REQUEST';
export const CR_SURVEY_SEND_FAILURE = 'CR_SURVEY_SEND_FAILURE';
export const CR_SURVEY_SEND_SUCCESS = 'CR_SURVEY_SEND_SUCCESS';

// QSR
export const QSR_SET = 'QSR_SET';
export const QSR_RESET_MESSAGE = 'QSR_RESET_MESSAGE';
export const QSR_REMOVE_NOTIFICATION = 'QSR_REMOVE_NOTIFICATION';
export const QSR_FETCH_REQUEST = 'QSR_FETCH_REQUEST';
export const QSR_FETCH_FAILURE = 'QSR_FETCH_FAILURE';
export const QSR_FETCH_SUCCESS = 'QSR_FETCH_SUCCESS';
export const QSRS_FETCH_REQUEST = 'QSRS_FETCH_REQUEST';
export const QSRS_FETCH_FAILURE = 'QSRS_FETCH_FAILURE';
export const QSRS_FETCH_SUCCESS = 'QSRS_FETCH_SUCCESS';
export const QSR_CREATE_REQUEST = 'QSR_CREATE_REQUEST';
export const QSR_CREATE_FAILURE = 'QSR_CREATE_FAILURE';
export const QSR_CREATE_SUCCESS = 'QSR_CREATE_SUCCESS';
export const QSR_UPDATE_REQUEST = 'QSR_UPDATE_REQUEST';
export const QSR_UPDATE_FAILURE = 'QSR_UPDATE_FAILURE';
export const QSR_UPDATE_SUCCESS = 'QSR_UPDATE_SUCCESS';
export const QSR_DELETE_REQUEST = 'QSR_DELETE_REQUEST';
export const QSR_DELETE_FAILURE = 'QSR_DELETE_FAILURE';
export const QSR_DELETE_SUCCESS = 'QSR_DELETE_SUCCESS';
export const QSR_CLONE_REQUEST = 'QSR_CLONE_REQUEST';
export const QSR_CLONE_FAILURE = 'QSR_CLONE_FAILURE';
export const QSR_CLONE_SUCCESS = 'QSR_CLONE_SUCCESS';

// QSR Manufacturers
export const QSR_MANUFACTURERS_FETCH_REQUEST =
	'QSR_MANUFACTURERS_FETCH_REQUEST';
export const QSR_MANUFACTURERS_FETCH_FAILURE =
	'QSR_MANUFACTURERS_FETCH_FAILURE';
export const QSR_MANUFACTURERS_FETCH_SUCCESS =
	'QSR_MANUFACTURERS_FETCH_SUCCESS';

// QSR Items
export const QSR_ITEM_CREATE_REQUEST = 'QSR_ITEM_CREATE_REQUEST';
export const QSR_ITEM_CREATE_FAILURE = 'QSR_ITEM_CREATE_FAILURE';
export const QSR_ITEM_CREATE_SUCCESS = 'QSR_ITEM_CREATE_SUCCESS';
export const QSR_ITEM_DELETE_REQUEST = 'QSR_ITEM_DELETE_REQUEST';
export const QSR_ITEM_DELETE_FAILURE = 'QSR_ITEM_DELETE_FAILURE';
export const QSR_ITEM_DELETE_SUCCESS = 'QSR_ITEM_DELETE_SUCCESS';

// QSR Types
export const QSR_TYPES_FETCH_REQUEST = 'QSR_TYPES_FETCH_REQUEST';
export const QSR_TYPES_FETCH_FAILURE = 'QSR_TYPES_FETCH_FAILURE';
export const QSR_TYPES_FETCH_SUCCESS = 'QSR_TYPES_FETCH_SUCCESS';

// QSR Categories
export const QSR_CATEGORIES_FETCH_REQUEST = 'QSR_CATEGORIES_FETCH_REQUEST';
export const QSR_CATEGORIES_FETCH_FAILURE = 'QSR_CATEGORIES_FETCH_FAILURE';
export const QSR_CATEGORIES_FETCH_SUCCESS = 'QSR_CATEGORIES_FETCH_SUCCESS';

// QSR Product types
export const QSR_PRODUCT_TYPES_FETCH_REQUEST =
	'QSR_PRODUCT_TYPES_FETCH_REQUEST';
export const QSR_PRODUCT_TYPES_FETCH_FAILURE =
	'QSR_PRODUCT_TYPES_FETCH_FAILURE';
export const QSR_PRODUCT_TYPES_FETCH_SUCCESS =
	'QSR_PRODUCT_TYPES_FETCH_SUCCESS';

// Oems
export const OEMS_FETCH_REQUEST = 'OEMS_FETCH_REQUEST';
export const OEMS_FETCH_FAILURE = 'OEMS_FETCH_FAILURE';
export const OEMS_FETCH_SUCCESS = 'OEMS_FETCH_SUCCESS';

export const OEM_CREATE_REQUEST = 'OEM_CREATE_REQUEST';
export const OEM_CREATE_FAILURE = 'OEM_CREATE_FAILURE';
export const OEM_CREATE_SUCCESS = 'OEM_CREATE_SUCCESS';

// End users
export const END_USERS_FETCH_REQUEST = 'END_USERS_FETCH_REQUEST';
export const END_USERS_FETCH_FAILURE = 'END_USERS_FETCH_FAILURE';
export const END_USERS_FETCH_SUCCESS = 'END_USERS_FETCH_SUCCESS';

// End user addresses
export const END_USER_ADDRESSES_FETCH_REQUEST =
	'END_USER_ADDRESSES_FETCH_REQUEST';
export const END_USER_ADDRESSES_FETCH_SUCCESS =
	'END_USER_ADDRESSES_FETCH_SUCCESS';
export const END_USER_ADDRESSES_FETCH_FAILURE =
	'END_USER_ADDRESSES_FETCH_FAILURE';

// End serial numbers
export const END_USER_SERIAL_NUMBER_RESET_MESSAGE =
	'END_USER_SERIAL_NUMBER_RESET_MESSAGE';
export const END_USER_SERIAL_NUMBERS_FETCH_REQUEST =
	'END_USER_SERIAL_NUMBERS_FETCH_REQUEST';
export const END_USER_SERIAL_NUMBERS_FETCH_FAILURE =
	'END_USER_SERIAL_NUMBERS_FETCH_FAILURE';
export const END_USER_SERIAL_NUMBERS_FETCH_SUCCESS =
	'END_USER_SERIAL_NUMBERS_FETCH_SUCCESS';
export const END_USER_SERIAL_NUMBER_CREATE_REQUEST =
	'END_USER_SERIAL_NUMBER_CREATE_REQUEST';
export const END_USER_SERIAL_NUMBER_CREATE_FAILURE =
	'END_USER_SERIAL_NUMBER_CREATE_FAILURE';
export const END_USER_SERIAL_NUMBER_CREATE_SUCCESS =
	'END_USER_SERIAL_NUMBERS_CREATE_SUCCESS';
export const END_USER_SERIAL_NUMBER_DELETE_REQUEST =
	'END_USER_SERIAL_NUMBER_DELETE_REQUEST';
export const END_USER_SERIAL_NUMBER_DELETE_FAILURE =
	'END_USER_SERIAL_NUMBER_DELETE_FAILURE';
export const END_USER_SERIAL_NUMBER_DELETE_SUCCESS =
	'END_USER_SERIAL_NUMBERS_DELETE_SUCCESS';

// Timezones
export const TIMEZONES_FETCH_REQUEST = 'TIMEZONES_FETCH_REQUEST';
export const TIMEZONES_FETCH_FAILURE = 'TIMEZONES_FETCH_FAILURE';
export const TIMEZONES_FETCH_SUCCESS = 'TIMEZONES_FETCH_SUCCESS';

// Sidebar
export const SIDEBAR_TOGGLE_VISIBILITY = 'SIDEBAR_TOGGLE_VISIBILITY';

// Search page
export const SEARCH_REQUEST = 'SEARCH_REQUEST';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';

// Browse
export const FOLDER_SET = 'FOLDER_SET';
export const FOLDER_FETCH_REQUEST = 'FOLDER_FETCH_REQUEST';
export const FOLDER_FETCH_FAILURE = 'FOLDER_FETCH_FAILURE';
export const FOLDER_FETCH_SUCCESS = 'FOLDER_FETCH_SUCCESS';

export const FOLDER_CREATE_REQUEST = 'FOLDER_CREATE_REQUEST';
export const FOLDER_CREATE_FAILURE = 'FOLDER_CREATE_FAILURE';
export const FOLDER_CREATE_SUCCESS = 'FOLDER_CREATE_SUCCESS';

export const FOLDER_UPDATE_REQUEST = 'FOLDER_UPDATE_REQUEST';
export const FOLDER_UPDATE_FAILURE = 'FOLDER_UPDATE_FAILURE';
export const FOLDER_UPDATE_SUCCESS = 'FOLDER_UPDATE_SUCCESS';

export const FOLDER_MOVE_REQUEST = 'FOLDER_MOVE_REQUEST';
export const FOLDER_MOVE_FAILURE = 'FOLDER_MOVE_FAILURE';
export const FOLDER_MOVE_SUCCESS = 'FOLDER_MOVE_SUCCESS';

export const FOLDER_DELETE_REQUEST = 'FOLDER_DELETE_REQUEST';
export const FOLDER_DELETE_FAILURE = 'FOLDER_DELETE_FAILURE';
export const FOLDER_DELETE_SUCCESS = 'FOLDER_DELETE_SUCCESS';

export const FOLDER_TOKEN_CREATE_REQUEST = 'FOLDER_TOKEN_CREATE_REQUEST';
export const FOLDER_TOKEN_CREATE_FAILURE = 'FOLDER_TOKEN_CREATE_FAILURE';
export const FOLDER_TOKEN_CREATE_SUCCESS = 'FOLDER_TOKEN_CREATE_SUCCESS';

export const FOLDER_TOKEN_DELETE_REQUEST = 'FOLDER_TOKEN_DELETE_REQUEST';
export const FOLDER_TOKEN_DELETE_FAILURE = 'FOLDER_TOKEN_DELETE_FAILURE';
export const FOLDER_TOKEN_DELETE_SUCCESS = 'FOLDER_TOKEN_DELETE_SUCCESS';

export const FILE_UPLOAD_REQUEST = 'FILE_UPLOAD_REQUEST';
export const FILE_UPLOAD_FAILURE = 'FILE_UPLOAD_FAILURE';
export const FILE_UPLOAD_SUCCESS = 'FOLDER_UPLOAD_SUCCESS';

export const FILE_DELETE_REQUEST = 'FILE_DELETE_REQUEST';
export const FILE_DELETE_FAILURE = 'FILE_DELETE_FAILURE';
export const FILE_DELETE_SUCCESS = 'FOLDER_DELETE_SUCCESS';

// Sourcesafe
export const SOURCESAFE_ENTRY_SET = 'SOURCESAFE_ENTRY_SET';
export const SOURCESAFE_ENTRY_SET_FILE = 'SOURCESAFE_ENTRY_SET_FILE';
export const SOURCESAFE_ENTRY_RESET_MESSAGE = 'SOURCESAFE_ENTRY_RESET_MESSAGE';
export const SOURCESAFE_ENTRIES_FETCH_REQUEST =
	'SOURCESAFE_ENTRIES_FETCH_REQUEST';
export const SOURCESAFE_ENTRIES_FETCH_FAILURE =
	'SOURCESAFE_ENTRIES_FETCH_FAILURE';
export const SOURCESAFE_ENTRIES_FETCH_SUCCESS =
	'SOURCESAFE_ENTRIES_FETCH_SUCCESS';
export const SOURCESAFE_ENTRY_CREATE_REQUEST =
	'SOURCESAFE_ENTRY_CREATE_REQUEST';
export const SOURCESAFE_ENTRY_CREATE_FAILURE =
	'SOURCESAFE_ENTRY_CREATE_FAILURE';
export const SOURCESAFE_ENTRY_CREATE_SUCCESS =
	'SOURCESAFE_ENTRY_CREATE_SUCCESS';
export const SOURCESAFE_ENTRY_DELETE_REQUEST =
	'SOURCESAFE_ENTRY_DELETE_REQUEST';
export const SOURCESAFE_ENTRY_DELETE_FAILURE =
	'SOURCESAFE_ENTRY_DELETE_FAILURE';
export const SOURCESAFE_ENTRY_DELETE_SUCCESS =
	'SOURCESAFE_ENTRY_DELETE_SUCCESS';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js